
import './App.css';
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Experience from './Experience';
import Work from './Work';
import Contact from './Contact';
function App() {
  return (
    <div >
     <Navbar/>
     <Home/>
     <About/>
     <Experience/>
     <Work/>
     <Contact/>
    </div>
  );
}

export default App;
